import Gravity from '../../../../../gravity-global/assets/js/global-functions';

const initializeNavOverflow = () => {
    const modulesArray = document.querySelectorAll('.gg-tabs-with-background-and-text');
    const resizeDelay = 10;

    modulesArray.forEach((module) => {
        const navParentElem = module.querySelector('.wp-block-statik-tabs');
        const navElem = module.querySelector('.wp-block-statik-tabs__nav');
        const navElemList = module.querySelector('.wp-block-statik-tabs__nav-list');

        const addClassOverflow = () => {
            if (navElemList?.scrollWidth > navParentElem?.offsetWidth) {
                navElem?.classList.add('overflowed-nav');
                return;
            }
            navElem?.classList.remove('overflowed-nav');
        };
        addClassOverflow();
        window.addEventListener('resize', Gravity.debounce(addClassOverflow, resizeDelay));
    });
};

Gravity.ready(initializeNavOverflow);
